<template>
<div>
    
    <div class="container_full">
        
        
        
        <div class="container">
            <div id="login">
                
                <div class="box_form">
                    <form @submit.prevent="login">

                        <div class="text-center">
                            <img src="@/assets/img/logo.png"/>
                        </div>
                        <h1>Ingreso de Farmcias</h1>
                        
                        <div class="form-group">
                            <input type="email" class="form-control" required placeholder="Ingrese su email" v-model="email">
						</div>
                        <div class="form-group">
                            <input type="password" class="form-control" required  placeholder="Ingrese su contraseña" v-model="pass">
						</div>
                        
                        <router-link class="link_bright" tag="a" to="/forgot-password">Olvidé mi contraseña</router-link>

                        <div class="alert alert-danger" v-if="loginError">
                            Usuario y/o contraseña incorrectos. 
                        </div>

                        <div class="form-group text-center add_top_20">
                            <input class="btn_1 medium" type="submit" value="Ingresar" v-if="!loginIn" >
                            <div class="btn_1 medium" v-else>
                                Ingresando...
                            </div>
						</div>
                        <p class="text-center">
                            ¿Todavía no tenés una cuenta?<br>
                            <router-link class="" tag="a" to="/register"><strong>Registrate ahora!</strong></router-link>
                        </p>
                    </form>
                </div>
            </div>
        </div>
    </div>
    <Footer></Footer>
</div>
</template>

<script>
import gql from 'graphql-tag'
import { onLogin } from '../../vue-apollo';
import { mapMutations } from 'vuex'


export default {
    name: 'Login',
    metaInfo: {
		title: 'Ingresar',
	},
    
    data() {
        return {
            email: '',
            pass: '',
            loginError:false,
            loginIn:false,
        }
    },
    beforeMount(){
        this.logout();
    },
    methods: {
		...mapMutations(['authSuccess','logout']),
        login() {
            this.loginError=false;
            if(!this.loginIn){
                this.loginIn = true;

                return this.$apollo.mutate({
                    mutation: gql`mutation userLogin($email:String!, $password:String! , $accessTo: String!){
                        pharmacyLogin( email: $email, password: $password, accessTo: $accessTo ){
                            token
							pharmacy{
								id
								name
								businessName
								email
							}
                        }
                    }`,
                    variables: {
                        email: this.email,
						password: this.pass,
						accessTo: 'admin'
                    },
                })
                .then( data => {
					console.log('login', data)
					let access_token = data.data.pharmacyLogin.token
                    let logged_pharmacy = data.data.pharmacyLogin.pharmacy
                    onLogin(this.$apollo.provider.defaultClient, access_token, logged_pharmacy).then(() => { 
						console.log('asds')
                        this.authSuccess({token:access_token, loggedPharmacy: logged_pharmacy})
						this.loading = false
						this.$emit('loadMe')
                        this.$router.push('/')
                    });
                })
                .catch((errors) => {
                    console.log(errors)
                    this.loginError=true;
                    this.loginIn = false;
				});



                // axios.post('/auth/medic/login', { email: this.email, password: this.pass })
                // .then(request => {
                //     if(request.data.access_token){
                //         let access_token = request.data.access_token;
                //         let logged_medic = request.data.user;
                //         onLogin(this.$apollo.provider.defaultClient, access_token, logged_medic).then(() => { 
                //             this.authSuccess({token:access_token, loggedPharmacy: logged_medic});
                //             this.$ga.event('medics', 'medic-logged', logged_medic.email)
                //             this.$router.push('/');
                //         });				
                //     }else{
                //         this.loginError=true;
                //         this.loginIn = false;
                //     }
                // })
                // .catch(() => 
                // {
                //     this.loginError=true;
                //     this.loginIn = false;
                // })
            }
			
		},
    }
}
</script>

<style scoped>

.container_full{
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
}

#login {
    width: 400px;
    margin: 60px auto;
    color: #5a5d5c;
}

@media (max-width: 767px) {
    #login {
        /* For less than 767px */
        width: 100%;
        margin: 30px 0;
    }
}

h1 {
    font-size: 22px;    
    text-align: center;
    margin: 20px 0 30px 0;
    
}

.divider {
    text-align: center;
    height: 1px;
    margin: 30px 0;
    background-color: #e1e8ed;
}

.divider span {
    position: relative;
    top: -20px;
    background-color: #fff;
    display: inline-block;
    padding: 10px;
    font-style: italic;
}


#login-2 {
    width: 650px;
    margin: 60px auto;
    color: #fff;
}

#login-2 .box_form {
    padding: 30px 0 0 0;
}

@media (max-width: 767px) {
    #login-2 .box_form {
        /* For less than 767px */
        padding: 20px 20px 0 20px;
    }
}

#login-2 .forgot {
    display: inline-block;
    margin-top: 5px;
}

@media (max-width: 767px) {
    #login-2 {
        /* For less than 767px */
        width: 100%;
        margin: 0;
    }
}

#login-2 h1 {
    font-size: 28px;
    font-size: 1.75rem;
    text-align: center;
    margin: 0 0 30px 0;
    color: #fff;
}

.box_login {
    width: 50%;
    float: left;
    border-right: 1px solid #e1e8ed;
    padding: 15px 25px;
}

@media (max-width: 767px) {
    .box_login {
        /* For less than 767px */
        width: 100%;
        border-right: 0;
        padding: 0;
    }
}

.box_login.last {
    border-right: 0;
}

a.social_bt {
    -webkit-border-radius: 3px;
    -moz-border-radius: 3px;
    -ms-border-radius: 3px;
    border-radius: 3px;
    text-align: center;
    color: #fff;
    min-width: 200px;
    margin-bottom: 15px;
    display: block;
    padding: 12px;
    line-height: 1;
    position: relative;
    -moz-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
    cursor: pointer;
}

a.social_bt:hover {
    -webkit-filter: brightness(115%);
    filter: brightness(115%);
}

a.social_bt.facebook:before,
a.social_bt.google:before,
a.social_bt.linkedin:before {
    font-family: 'ElegantIcons';
    position: absolute;
    left: 12px;
    top: 10px;
    font-size: 1rem;
    color: #fff;
}

a.social_bt.facebook {
    background-color: #3B5998;
}

a.social_bt.facebook:before {
    content: "\e093";
}

a.social_bt.google {
    background-color: #DC4E41;
}

a.social_bt.google:before {
    content: "\e096";
    top: 12px;
}

a.social_bt.linkedin {
    background-color: #0077B5;
}

a.social_bt.linkedin:before {
    content: "\e09d";
}
</style>
